import React from 'react'

import s from './styles.module.scss'

import {
  getNestedItemIcon,
  getNestedItemQuantity,
  getNestedItemUnit,
} from './utils'
import { NestedItemObjectDataOutputDto } from '../../../../../../lib/graphql'
import Icon from '../../../../../atoms/icons/icon/Icon'

const SelectProposalMenuNestedItems = ({
  nestedItems,
}: {
  nestedItems: NestedItemObjectDataOutputDto[]
}) => {
  return (
    <div className={s.nestedItemsList}>
      {nestedItems.map((nestedItem) => (
        <div
          key={`${nestedItem.type}${nestedItem.objectId ? `_${nestedItem.objectId}` : ''}`}
          className={s.nestedItem}
        >
          <Icon name={getNestedItemIcon({ nestedItem })} size={14} />
          <div className={s.nestedItemLabel}>
            {nestedItem.label}
            {getNestedItemQuantity({ nestedItem })}
            {getNestedItemUnit({ nestedItem })}
          </div>
        </div>
      ))}
    </div>
  )
}

export default SelectProposalMenuNestedItems
